import { useState, useEffect } from 'react';
import General from 'components/general';
import Internet from 'components/internet';
import { useHistory } from 'react-router-dom'
import strings from '../../strings/strings.json'
import License from 'components/license';
import Yara from 'components/yara';
import { productDetails } from 'api/api_service';
import { IProductDetails } from 'types';
import Layout from 'components/layout';

export default function Settings() {
  const history = useHistory()
  const [activeId, setActiveId] = useState(1)
  const [productDetail, setProductDetail] = useState<IProductDetails>()

  useEffect(() => {
    productDetails()
      .then(res => {
        if (res.status === 200 && res.data.success)
          setProductDetail(res.data.data)
      })
  }, [])

  const renderData = (title: string, id: number) => {
    return (
      <div className='flex justify-center flex-col items-center py-1'>
        <span className={`font-bold primary_text_color ${id === activeId ? 'text_primary_color' : 'secondry_text_color'}`}>{title}</span>
      </div>
    )
  }

  const uiRender = () => {

    switch (activeId) {
      case 1:
        return <General />
      case 2:
        return <Internet />
      case 3:
        return <License />
      case 4:
        return <Yara />
      default:
        break;
    }
  }

  return (
    <Layout>
      <div dir='rtl' className='px-10 mb-20 absolute w-full mt-32 top-0 bottom-0'>
        <div className='mt-10'><span className='primary_text_color font-bold text-lg'>{strings.settings_title}</span></div>
        <div className={`grid w-full text-center justify-around border border-gray-100 rounded-lg mt-7 ${(productDetail !== undefined && productDetail.os === "Linux") ? 'grid-cols-4' : 'grid-cols-3'}`}>
          <div
            className={`${activeId === 1 ? 'border-b-4 border-b-blue-500 bg-gray-100' : ''} border-l cursor-pointer`}
            onClick={() => setActiveId(1)}>
            {renderData(strings.settings_general, 1)}
          </div>
          {
            (productDetail !== undefined && productDetail.os === "Linux") &&
            <div
              className={` ${activeId === 2 ? 'border-b-4 border-b-blue-500 bg-gray-100' : ''} border-l cursor-pointer`}
              onClick={() => setActiveId(2)}>
              {renderData(strings.settings_internet, 2)}
            </div>
          }
          <div
            className={`${activeId === 3 ? 'border-b-4 border-b-blue-500 bg-gray-100' : ''} border-l  cursor-pointer`}
            onClick={() => setActiveId(3)}>
            {renderData(strings.settings_license, 3)}
          </div>
          <div
            className={`${activeId === 4 ? 'border-b-4 border-b-blue-500 bg-gray-100' : ''} cursor-pointer`}
            onClick={() => setActiveId(4)}>
            {renderData(strings.settings_yaraEngine, 4)}
          </div>
        </div>
        <div>
          {uiRender()}
        </div>
      </div>
    </Layout>
  )
}
